import { router, usePage } from "@inertiajs/react";
import { loginPath } from "@travily/routes";
import { useCallback, useEffect, useState } from "react";
import { submitFavoriteToggle } from "@/lib/favorite-toggle";
import type { SharedProps } from "@/types";

interface UseFavoriteOptions {
  favorited: boolean;
  favorableType: string;
  favorableId: string | number;
}

interface UseFavoriteReturn {
  isFavorited: boolean;
  toggle: () => void;
}

export function useFavorite({ favorited, favorableType, favorableId }: UseFavoriteOptions): UseFavoriteReturn {
  const { current_user } = usePage<SharedProps>().props;
  const [localFavorited, setLocalFavorited] = useState(favorited);

  useEffect(() => setLocalFavorited(favorited), [favorited]);

  const toggle = useCallback(() => {
    if (!current_user) {
      router.visit(loginPath());
      return;
    }

    const wasFavorited = localFavorited;
    setLocalFavorited(!wasFavorited);

    submitFavoriteToggle({
      favorableType,
      favorableId,
      wasFavorited,
      onRollback: () => setLocalFavorited(wasFavorited),
    });
  }, [current_user, localFavorited, favorableType, favorableId]);

  return { isFavorited: localFavorited, toggle };
}
